import { useMsal } from "@azure/msal-react";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { Channel } from "./useGetTeams";
import axios from "@/configs/axios";
import { KB_SOURCE } from "@/util/constants";

export const useGetChannels = (
  loginRequestForBackend: any,
  teamId: string,
  options?: Omit<UseQueryOptions<Channel[], Error>, "queryKey" | "queryFn">
) => {
  const { instance, accounts } = useMsal();

  return useQuery<Channel[], Error>({
    queryKey: ["/getChannels", KB_SOURCE, accounts[0]?.homeAccountId, teamId],
    enabled: !!accounts[0] && !!teamId,
    queryFn: async () => {
      const response = await instance.acquireTokenSilent({
        ...loginRequestForBackend,
        account: accounts[0],
      });
      const url = `${process.env.REACT_APP_SERVER_HOST}/teams-sync/teams/${teamId}/channels`;
      const { data } = await axios.get(url, {
        headers: {
          oboToken: `${response.accessToken}`,
        },
      });

      return data;
    },
    ...options,
  });
};
